export default __webpack_public_path__ + "static/llama-run-screenshot-9df8992c051e584a243ca35fa46316e1.png";